// Fixed names
export const SKELETON_CUSTOM_SIZE = "custom";
